import type { AddressSuggestionKind } from './types'

/**
 * Виды, для которых в интерфейсе есть отдельная подпись. Всё остальное
 * (устаревшие уровни ГАР вроде `autonomous_okrug`, `car_place` и т.п.,
 * а также нераспознанный бэкендом `unknown`) сворачивается в `other`.
 */
const KNOWN_KINDS: ReadonlySet<AddressSuggestionKind> = new Set([
  'region',
  'admin_area',
  'municipal_area',
  'settlement_area',
  'city',
  'locality',
  'planning_structure',
  'street',
  'stead',
  'house',
  'room',
  'room_part',
  'other',
])

/**
 * Запасной путь, если бэкенд не прислал `kind`: зеркало `LevelKind` из
 * `fias/internal/domain/models/levels.go`, чтобы подпись не расходилась
 * с бэкендом при отсутствии строкового поля в ответе.
 */
const KIND_BY_GAR_LEVEL: Record<number, AddressSuggestionKind> = {
  1: 'region',
  2: 'admin_area',
  3: 'municipal_area',
  4: 'settlement_area',
  5: 'city',
  6: 'locality',
  7: 'planning_structure',
  8: 'street',
  9: 'stead',
  10: 'house',
  11: 'room',
  12: 'room_part',
}

export function resolveSuggestionKind(kind: unknown, level: unknown): AddressSuggestionKind {
  if (typeof kind === 'string') {
    const normalized = kind.trim().toLowerCase() as AddressSuggestionKind
    if (KNOWN_KINDS.has(normalized)) return normalized
  }

  if (typeof level === 'number' && Number.isFinite(level)) {
    return KIND_BY_GAR_LEVEL[level] ?? 'other'
  }

  return 'other'
}

/** Ключ перевода для серой подписи под названием. */
export function addressKindLabelKey(kind: AddressSuggestionKind): string {
  return `itf.address_kind_${kind}`
}
